<div
    class="formHolder"
    style="display: grid"
>
    <h1 class="form-title">Change password</h1>
    <mat-divider></mat-divider>
    <div
        *ngIf="displayMessage"
        class="errMessage"
    >
        {{ message }}
    </div>
    <form
        class="example-form"
        [formGroup]="passwordForm"
    >
        <mat-form-field
            class="example-full-width"
            appearance="fill"
        >
            <mat-label>Old Password</mat-label>
            <input
                matInput
                formControlName="oldPassword"
                type="password"
            />
            <mat-error *ngIf="checkError('oldPassword', 'required')"
                >Old Password is required.</mat-error
            >
        </mat-form-field>

        <mat-form-field
            class="example-full-width"
            appearance="fill"
        >
            <mat-label>New Password</mat-label>
            <input
                matInput
                formControlName="newPassword"
                type="password"
            />
            <mat-error *ngIf="checkError('newPassword', 'required')"
                >New Password is required.</mat-error
            >
        </mat-form-field>

        <mat-form-field
            class="example-full-width"
            appearance="fill"
        >
            <mat-label>Confirm New Password</mat-label>
            <input
                matInput
                formControlName="confirmedPassword"
                type="password"
            />
            <mat-error
                *ngIf="submitted && checkError('confirmedPassword', 'required')"
                >Confirmed Password is required.</mat-error
            >
            <mat-error
                *ngIf="
                    submitted &&
                    passwordForm.get('confirmedPassword').errors
                        ?.retypedValidator
                "
                >Password and Confirmed Password don't match.
            </mat-error>
        </mat-form-field>

        <section>
            <button
                mat-stroked-button
                color="primary"
                (click)="onSubmit()"
            >
                Update password
            </button>
        </section>
    </form>
</div>
